export default __webpack_public_path__ + "static/media/me.7caa354d.jpg";